module.exports = __webpack_public_path__ + "media/images/common/apple-7b452653e97f174548af63679f82ddf1.png";